import { LegalPage } from '#app/components/legal-page.tsx'
import { type Route } from './+types/privacy.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Datenschutzerklärung · Kuratier' },
]

export default function PrivacyRoute() {
	return (
		<LegalPage title="Datenschutzerklärung" updated="04.08.2026">
			<section>
				<h2>1. Verantwortlicher</h2>
				<p>
					dataso GmbH, Tilsiter Str. 1, 64342 Seeheim-Jugenheim
					<br />
					Geschäftsführer: Dawid Sochacki
					<br />
					E-Mail: <a href="mailto:dawid@dataso.de">dawid@dataso.de</a>
				</p>
			</section>

			<section>
				<h2>2. Welche Daten wir verarbeiten</h2>
				<h3>2.1 Konto</h3>
				<p>
					E-Mail-Adresse, frei wählbarer Alias, Passwort (ausschließlich als
					Hash gespeichert). Zweck: Bereitstellung des Dienstes.
					Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO. Eine Klarnamenpflicht
					besteht nicht.
				</p>
				<h3>2.2 Eingebundene Quellen</h3>
				<p>
					Von dir hinterlegte Playlist-URLs bzw. hochgeladene Playlists,
					ausgewählte Streaming-Abos und Mediatheken-Einstellungen. Zweck:
					Kernfunktion der Plattform. Rechtsgrundlage: Art. 6 Abs. 1 lit. b
					DSGVO.{' '}
					<strong>Playlists sind ausschließlich für dich sichtbar</strong> und
					werden nicht an Dritte übermittelt — auch nicht an unsere
					Metadaten-Anbieter. An Drittdienste (TMDB, OMDb) werden ausschließlich
					bereinigte Titelnamen und Jahreszahlen übermittelt, ohne Bezug zu
					deinem Konto.
				</p>
				<h3>2.3 Nutzungsdaten der Plattform</h3>
				<p>
					Likes, Bewertungen, Kommentare, Watchlist, Geschaut-Status,
					gespeicherte Filter, Wiedergabepositionen. Zweck: Kernfunktionen.
					Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO. Sichtbarkeit: Bewertungen
					und Kommentare für von dir bestätigte Freunde (pro Eintrag auf
					„privat" stellbar); alle übrigen Daten nur für dich.
				</p>
				<h3>2.4 Server- und Zugriffsprotokolle</h3>
				<p>
					Beim Zugriff auf die Plattform werden technisch bedingt IP-Adresse,
					Zeitpunkt, abgerufene Ressource, Statuscode und User-Agent
					verarbeitet. Zweck: Betriebssicherheit, Fehleranalyse und Abwehr
					missbräuchlicher Zugriffe. Rechtsgrundlage: Art. 6 Abs. 1 lit. f
					DSGVO. Diese Protokolle entstehen bei unseren Hosting- und
					Sicherheitsdienstleistern (siehe Ziffer 3) und werden nach deren
					jeweiliger Standard-Aufbewahrungsfrist automatisch gelöscht; eine
					darüber hinausgehende Speicherung durch uns erfolgt nicht. In der
					Anwendungsdatenbank werden IP-Adressen nicht gespeichert und nicht mit
					Kontoaktivitäten verknüpft.
				</p>
				<h3>2.5 Cookies</h3>
				<p>
					Ausschließlich technisch notwendige Cookies (Session/Login). Keine
					Tracking-, Analyse- oder Werbe-Cookies und keine Drittanbieter-Cookies
					— daher ist kein Einwilligungsbanner erforderlich (§ 25 Abs. 2 TDDDG).
				</p>
				<h3>2.6 Schriftarten und externe Ressourcen</h3>
				<p>
					Alle Schriftarten, Skripte und Stylesheets werden von unseren eigenen
					Servern ausgeliefert. Ein Abruf bei Google Fonts oder vergleichbaren
					Anbietern findet nicht statt.
				</p>
				<p>
					<strong>Bilder sind die Ausnahme.</strong> Cover, Vorschaubilder,
					Wappen und Senderlogos werden nicht von uns gespiegelt, sondern beim
					jeweiligen Anbieter geladen. Dein Browser baut dafür eine direkte
					Verbindung zu diesem Anbieter auf; dabei werden — technisch bedingt —
					deine IP-Adresse, dein User-Agent und die aufgerufene Seite als
					Referrer übertragen. Cookies setzen diese Anbieter dabei nicht.
					Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (Darstellung der Inhalte
					ohne Vervielfältigung fremder Bilder auf unseren Servern).
				</p>
				<ul>
					<li>
						<strong>Cover und Logos:</strong> TMDB (image.tmdb.org).
					</li>
					<li>
						<strong>Vorschaubilder aus den Mediatheken:</strong> ARD
						(api.ardmediathek.de).
					</li>
					<li>
						<strong>Trailer:</strong> Vorschaubild von i.ytimg.com; der Player
						selbst wird erst nach einem Klick geladen und läuft über
						youtube-nocookie.com.
					</li>
					<li>
						<strong>Vereinswappen:</strong> die in den Sportdaten hinterlegten
						Bildadressen (u. a. crests.football-data.org, upload.wikimedia.org).
					</li>
					<li>
						<strong>Senderlogos:</strong> die Adressen aus der von dir
						eingebundenen Quelle. Welcher Anbieter das ist, bestimmst
						ausschließlich du mit der Wahl deiner Quelle.
					</li>
				</ul>
			</section>

			<section>
				<h2>3. Hosting, Versand und Auftragsverarbeiter</h2>
				<ul>
					<li>
						<strong>Hosting:</strong> Fly.io, Inc. (USA), Serverstandort
						Frankfurt am Main.
					</li>
					<li>
						<strong>Sicherheit und Auslieferung (CDN/WAF):</strong> Cloudflare,
						Inc. (USA).
					</li>
					<li>
						<strong>E-Mail-Versand:</strong> Resend (Plus Five Five, Inc., USA)
						— für Registrierungs-, Sicherheits- und Benachrichtigungs-E-Mails;
						verarbeitet werden E-Mail-Adresse und Versandmetadaten.
					</li>
				</ul>
				<p>
					Mit allen genannten Dienstleistern bestehen Verträge zur
					Auftragsverarbeitung (Art. 28 DSGVO). Soweit Daten in die USA
					übermittelt werden, erfolgt dies auf Grundlage der
					EU-Standardvertragsklauseln bzw. einer Zertifizierung nach dem EU-US
					Data Privacy Framework.
				</p>
			</section>

			<section>
				<h2>4. Weitergabe von Daten</h2>
				<p>
					Eine Weitergabe personenbezogener Daten an Dritte erfolgt nicht, außer
					wir sind gesetzlich dazu verpflichtet (z. B. aufgrund einer
					vollstreckbaren behördlichen oder gerichtlichen Anordnung). In diesem
					Fall prüfen wir die Rechtmäßigkeit des Ersuchens und geben
					ausschließlich diejenigen Daten heraus, zu deren Herausgabe wir
					konkret verpflichtet sind. Wir verkaufen keine Daten und betreiben
					kein Werbe-Tracking.
				</p>
			</section>

			<section>
				<h2>5. Speicherdauer und Löschung</h2>
				<p>
					Konto- und Nutzungsdaten werden bei Löschung deines Kontos
					unverzüglich gelöscht; in Sicherungskopien werden sie spätestens nach
					30 Tagen überschrieben. Für Protokolldaten gilt Ziffer 2.4.
					Gesetzliche Aufbewahrungspflichten bleiben unberührt.
				</p>
			</section>

			<section>
				<h2>6. Deine Rechte</h2>
				<p>
					Dir stehen die Rechte auf Auskunft (Art. 15), Berichtigung (Art. 16),
					Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18),
					Datenübertragbarkeit (Art. 20) und Widerspruch (Art. 21) sowie das
					Recht zu, erteilte Einwilligungen jederzeit zu widerrufen. Du hast
					außerdem das Recht auf Beschwerde bei einer Aufsichtsbehörde; für uns
					zuständig ist Der Hessische Beauftragte für Datenschutz und
					Informationsfreiheit.
				</p>
			</section>
		</LegalPage>
	)
}
